import classnames from 'clsx'
import { SpaceProps } from 'styles/styled'
import { StyledMediaBody } from './style'

interface IMediaBodyProps extends SpaceProps {
  className?: string
  children: React.ReactNode
  style?: React.CSSProperties
}

const MediaBody = ({
  children,
  className,
  style,
  ...restProps
}: IMediaBodyProps) => {
  return (
    <StyledMediaBody
      className={classnames(className, 'media-body')}
      style={style}
      {...restProps}
    >
      {children}
    </StyledMediaBody>
  )
}

export default MediaBody
